import { GlobalSearch } from "@/dtos/Search.dto";
import { StateObject } from "@/dtos/State.dto";
import Search from "@/services/search";
import { CLEAR_SEARCH_ISLOADING, GLOBAL_SEARCH } from "@/store/action-types";
import { SET_ERRORMSG, SET_GLOBAL_SEARCH } from "@/store/mutation-types";
import { AxiosResponse } from "axios";
import { Module } from "vuex";

const search: Module<any, {}> = {
  state: {
    globalSearch: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    globalSearch: (state: { globalSearch: any }) => state.globalSearch,
  },
  mutations: {
    [SET_GLOBAL_SEARCH]: (
      state: { globalSearch: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.globalSearch.data = payload.data;
      state.globalSearch.isLoading = payload.isLoading;
    },
  },
  actions: {
    [GLOBAL_SEARCH]: async ({ commit }: any, payload: any) => {
      commit(SET_GLOBAL_SEARCH, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await Search.globalSearch(payload as GlobalSearch);

        if (result?.data?.status) {
          commit(SET_GLOBAL_SEARCH, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }

        commit(SET_GLOBAL_SEARCH, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result?.data?.msg ?? "Search failed.");
        return false;
      } catch (err: any) {
        commit(SET_GLOBAL_SEARCH, { data: null, isLoading: false });
        commit(SET_ERRORMSG, err?.message ?? "Network error. Please try again.");
        return false;
      }
    },
    [CLEAR_SEARCH_ISLOADING]: ({ commit }) => {
      commit(SET_GLOBAL_SEARCH, { isLoading: false });
    },
  },
};

export default search;
